// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a4dbd749","239":"ba95c519","455":"5d606585"}[chunkId] + ".chunk.js";
};